import React from "react"
import { Player } from "video-react"
import YouTubePlayer from "react-player/youtube"

const VideoPlayer = ({
  url,
  width,
  height,
  poster = "",
  youtube = false,
  autoPlay = true,
  videoConfig
}: {
  url: string
  width?: number | string;
  height?: number
  poster?: string
  youtube?: boolean
  autoPlay?: boolean
  videoConfig?: any
}) => {
  if (youtube) {
    const config = {
      youtube: {
        playerVars: {
          showinfo: 0,
          autoplay: autoPlay ? 1 : 0,
          controls: 0,
          playsinline: 1,
          mute: autoPlay ? 1 : 0,
          loop: 1,
          disablekb: 1,
        },
      },
    }
    return (
      <YouTubePlayer
        width={width}
        height={height}
        playing={autoPlay}
        className="react-player"
        {...config}
        url={url}
        muted={autoPlay}
        volume={autoPlay ? 0 : 100}
        loop={true}
        playsinline={true}
      />
    )
  }

  return (
    <div className="video-player">
      <Player
        width={width}
        height={height}
        autoPlay
        muted
        poster={poster}
        playsInline
        // @ts-ignore
        loop
        {...videoConfig}
      >
        <source src={url} />
      </Player>
    </div>
  )
}

export default VideoPlayer
